export const addBrowsingParameter = (url: string) => {
  return addParameter(url, 'browsing', '1')
}

export const addParameter = (url: string, key: string, value: string) => {
  const queryParam = `${key}=${value}`
  const [currentUrl, fragment] = url.split('#')
  const afterQueryString = fragment != null ? `${queryParam}#${fragment}` : queryParam
  return currentUrl.includes('?') ? `${currentUrl}&${afterQueryString}` : `${currentUrl}?${afterQueryString}`
}

export const addParameters = (url: string, parameters: Record<string, string>) => {
  return Object.keys(parameters).reduce((url, key) => addParameter(url, key, parameters[key]), url)
}
